import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(items: any, column: string, type: string) {
    let sortedItems = [];
    if(items){
      if (type == "asc") {
        sortedItems = this.sortAscending(items, column);
      } else if(type == "desc") {
        sortedItems = this.sortDescending(items, column);
      } 
      else {
        sortedItems = this.sortAlphabetical(items, column);
      }
    }
    return sortedItems;
  }

  sortAlphabetical(items: any, column: any){    
    return [...items.sort((a:any,b:any) => {
      if (a[column].toUpperCase() < b[column].toUpperCase()){
        return -1
      }else{
        return 1;
      }
    })];
  }
  
  sortAscending(items: any, column: any) {
    return [...items.sort((a:any,b:any) => {
      return a[column] - b[column];
    })];
  }

  sortDescending(items: any, column: any) {
    return [...items.sort((a: any, b: any) => {
      return b[column] - a[column];
    })];
  }
}
